import './content'
import http from 'libs/http'
http.setMockRule(false, mock => {
  mock.onAny(/messageStation\/list/).reply(() => {
    return [200, {
      code: 0,
      data: {
        "page": {
          "prePage": 1, 
          "nextPage": 2, 
          "pageNo": 1, 
          "pageSize": 20, 
          "totalPage": 2, 
          "totalCount": 22
        }, 
        statusList: [
          {
            code: 1,
            msg: '已发送'
          },
          {
            code: 0,
            msg: '未发送'
          }
        ],
        targetList: [

        ],
        hasPushList: [

        ]
      }
    }]
  })
  mock.onAny('/sys/menu/top').reply(() =>{
    return [200, {
      code: 0,
      data: {
        siteName: "36氪_主站",
        userName: "赵www",
      }
    }]
  })
  mock.onAny('sys/menu/init').reply(() =>{
    return [200, 
      {"code":0,"data":{"appList":[{"appId":55,"name":"内容信息系统","serverDomain":"mis-dev.corp.36kr.com","frontDomain":"//mis-dev.corp.36kr.com"}],"menuList":[{"name":"内容管理","url":"/home/content","icon":"desktop","childMenuList":[{"name":"日签管理","url":"/home/content/dailyword","icon":""},{"name":"运营位管理","url":"/home/content/operation","icon":""},{"name":"运营位配置管理","url":"/home/content/operationConf","icon":""},{"name":"快讯管理","url":"/home/content/newsflash","icon":""},{"name":"评论配置","url":"/home/content/commentConfigure","icon":""},{"name":"评论管理","url":"/home/content/comment","icon":""}]},{"name":"系统管理","url":"/home/sys","icon":"setting","childMenuList":[{"name":"分享管理","url":"/home/sys/share","icon":""},{"name":"权限管理","url":"/home/sys/authority","icon":""},{"name":"平台管理","url":"/home/sys/platform","icon":""},{"name":"尺寸管理","url":"/home/sys/panel","icon":""},{"name":"模版管理","url":"/home/sys/temp","icon":""}]},{"name":"聚合管理","url":"/home/polymerize","icon":"appstore","childMenuList":[{"name":"主题管理","url":"/home/polymerize/theme","icon":""},{"name":"身份主题","url":"/home/polymerize/identity","icon":""}]}],"functionList":["dailyword","dailyword_add","dailyword_mod","dailyword_search","comment","commentOperate","commentTalk","commentConfigure","commentConfigure","templateDel","templateAdd","templateMod","templateDetail","templateList","panelList","panelModInit","panelAdd","panelDel","panelDetail","panelOnline","platformList","platformAdd","platformDel","platformMod","userList","userEdit","channelSharelist","channelShareAdd","channelShareDel","channelShareMod","channelShareWeight","newsflashList","newsflashListAdd","newsflashListEdit","newsflashListItemPush","newsflashListItemOffline","newsflashListItemMarkRed","identityThemeList","identityThemeListEdit","operationConf","themeList","themeListSort","themeAdd","themeBest","themeFollowPlus","themeStatus","themeMod","operation"]}}
    ]
  })

  mock.onAny('/sys/index/choiceInit').reply(() =>{
    return [200, 
      {"code":0,"data":{"siteList":[{"id":1,"name":"36氪_主站"},{"id":1001,"name":"零售老板内参_主站"}]}}
    ]
  })

})